// extracted by css-extract-rspack-plugin
export default {"flex":"flex-V9oheR","root":"root-iRan6J flex-V9oheR","content":"content-l_kAtV flex-V9oheR"};